import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <h1 className="footerTitle text-center">
          <span className="orange">E</span>lya<span className="orange">M</span>
          any
        </h1>
        <div className="row">
          <div className="col-sm-6 right">
            <ul className="list-unstyled">
              <li>
                <FontAwesomeIcon
                  icon={faPhoneAlt}
                  style={{ marginRight: "10px" }}
                />
                Tele: <span>+201124762799</span>
              </li>
              <li>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  style={{ marginRight: "10px" }}
                />
                Email: <span>ko5418301@gmail.com</span>
              </li>
            </ul>
          </div>
          <div className="col-sm-2"></div>
          <div className="col-sm-4">
            <ul className="list-unstyled social">
              <li>
                <a
                  href="https://www.facebook.com/karim.osama.585112/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faFacebook}
                    style={{ fontSize: "40px" }}
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/karim_osama_elyamany/"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    style={{ fontSize: "40px" }}
                  />
                </a>
              </li>
              <li>
                <a href="https://twitter.com/KarimOs71507954" target="_blank">
                  <FontAwesomeIcon
                    icon={faTwitter}
                    style={{ fontSize: "40px" }}
                  />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCBD1fGHEmR78_uQ76sQ8J-A"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    icon={faYoutube}
                    style={{ fontSize: "40px" }}
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p className="text-center">
          2021-2022 All Rights Reserved To{" "}
          <span className="developer">Karim Osama</span>
        </p>
      </div>
    </div>
  );
};

export default Footer;
